import { biText } from '@euler/app/components/message/widgets/bi-visualization/functions/biText';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BiDatasetCatalog } from '@euler/model/bi/catalog';
import { Table2 } from 'lucide-react-native';
import { memo } from 'react';
import { BiTag } from '../../components/ui/BiTag';
import { LibraryTile } from './LibraryTile';

/** A built-in dataset: read-only, so users know what they can ask about. */
export const BuiltinTile = memo(
  ({ catalog, onOpen }: { catalog: BiDatasetCatalog; onOpen: () => void }) => {
    const name = biText(catalog.label);
    return (
      <LibraryTile
        icon={Table2}
        color={aiColors.blue}
        name={name}
        accessibilityLabel={`打开数据 ${name}`}
        onPress={onOpen}
        tags={<BiTag text="内置" color={aiColors.blue} />}
        lines={[biText(catalog.description), `${catalog.fields.length} 个字段`]}
      />
    );
  },
);
